/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Incomplete_Confirm_Data_GroupInputs */

const en_case_create_incomplete_confirm_data_group = /** @type {(inputs: Case_Create_Incomplete_Confirm_Data_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const pt_br2_case_create_incomplete_confirm_data_group = /** @type {(inputs: Case_Create_Incomplete_Confirm_Data_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados`)
};

/**
* | output |
* | --- |
* | "Data" |
*
* @param {Case_Create_Incomplete_Confirm_Data_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_confirm_data_group = /** @type {((inputs?: Case_Create_Incomplete_Confirm_Data_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_Confirm_Data_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_confirm_data_group(inputs)
	return pt_br2_case_create_incomplete_confirm_data_group(inputs)
});